// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ warehouseOverride: string }>;

export const DispatchSetWarehouseOverride: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/SetWarehouseOverride",
        warehouseOverride: props.parameter.warehouseOverride,
    });
};

export const chain = [DispatchSetWarehouseOverride];

const setWarehouseOverride = createHandlerChainRunner(chain, "SetWarehouseOverride");
export default setWarehouseOverride;
